import { isEmpty } from 'lodash';
import { getThemeEnabled, hasThemeAccess } from 'rest/dist/gen/api/shops/shops';

export const initialProductCountdownSettingsLabels = {
  containsProductTitle: true,
  afterProductTitleText: 'SALE ENDS IN',
  beforeProductTitleText: '',
  footerText: '',
  daysLabel: 'Days',
  hoursLabel: 'Hours',
  minutesLabel: 'Minutes',
  secondsLabel: 'Seconds',
};

export const initialProductCountdownSettingsColors = {
  textColor: '#333333',
  digitColor: '#FF5F5B',
  digitBackgroundColor: '#f8f4f1',
  progressBarColor: '#FF5F5B',
  progressBarBorderColor: '#808080',
};

export const initialProductCountdownSettings = {
  IsActive: false,
  ...initialProductCountdownSettingsLabels,
  ...initialProductCountdownSettingsColors,
};

const initialProductEmbedSetting = {
  IsActive: false,

  Buy: 'Buy',
  get: 'get',
  off: 'off',
  items: 'items',
  Purchase: 'purchase',
  to: 'to',
  off_by_purchasing: 'off by purchasing',
  Save: 'save',
  bypurchasing: 'by purchasing',
  Buy_at_least: 'Buy at least',

  total: 'Total',
  peritem: 'per item',
  oneach: 'on each',

  // not show in preview
  between: 'between',
  and: 'and',
  discountonyourtotalpurchase: 'Discount on your total purchase',

  header_color: '#000000',
  description_color: '#898f94',
  badge_color: '#FF0101',
  border_color: '#898f94',
  border_color_selected: '#8CB540',
  radio_color: '#8CB540',
};

const initialCartEmbedSetting = {
  IsActive: false,
  totalLabel: 'Subtotal',
  savedLabel: 'Saved (on sale)',
  totalColor: '#000000',
  savedColor: '#45946D',
  savedBgColor: '#D9F0E4',
  align: 'default',
  lineThrough: 'true',
  boarderinSavedColor: '#45946D',
  borderRadius: 8,
  showBorder: true,
};

const initialInventoryEmbedSetting = {
  IsActive: false,
  Position: 'below',
  StockLessNumber: 5,
  Text: '🔥 Only {live_stock_count} in stock',
  TextColor: '#8E1F0B',
  BackgroundColor: '#FEDAD9',
};

const initialShippingEmbedSetting = {
  IsActive: false,
  showOnProductPage: false,
  showOnCartPage: true,
  progressMessage: 'Buy {quantity/amount} more to get {discount}',
  initialMessage: 'Add {{amount}} more to unlock {{discount}} off shipping!',
  inProgressMessage: "You're {{amount}} away from {{discount}} off shipping!",
  thresholdReachedMessage: "You've unlocked {{discount}} off shipping!",
  // Card styles
  cardTextSize: 12,
  textColor: '#000000',
  backgroundColor: '#FFFFFF',
  cardBorderColor: '#000000',
  cardBorderRadius: 8,
  // Progress bar styles
  progressBackground: '#D9D9D9',
  progressColor: '#19A07F',
  progressBarBorderRadius: 4,
};

const initialBundleEmbedSetting = {
  IsActive: false,

  WidgetBackgroundColor: '#F7F7F7',
  HeaderBackgroundColor: '#CDFEE1',
  TitleColor: '#303030',
  SubTitleColor: '#616161',
  TextColor: '#303030',

  GiftBorderColor: '#A8D8FF',
  GiftBackgroundColor: '#EAF4FF',
};

const initialBogoFabSetting = {
  IsActive: false,
  removeCloseButton: false,
  position: 'left',
  borderRadius: 16,
  fabBackgroundColor: '#03A87C',
  fabIconColor: '#FFFFFF',
  closeButtonColor: '#FFFFFF',
  closeButtonIconColor: '#C0C0C0',
};

const initialBogoModalSetting = {
  IsActive: false,
  // Text customization — Header texts
  headerTitle: 'Your current cart qualifies for these rewards',
  headerSubtitle: 'Now you are able to choose between them. Add before checking out!',
  // Text customization — Button labels
  selectButtonText: 'Select',
  addToCartButtonText: 'Add to Cart',
  continueShoppingButtonText: 'Continue Shopping',
  removeContinueShopping: false,
  // Discount badge
  badgeType: 'percentage', // 'percentage' | 'amount'
  showFreeGiftBadge: true,
  // Color palette — Theme colors
  primaryColor: '#000000',
  secondaryColor: '#FFFFFF',
  borderColor: '#C0C0C0',
  // Color palette — Element colors
  popupBackgroundColor: '#F4F4F4',
  headerBackgroundColor: '#616161',
  headerTextColor: '#FFFFFF',
  saleBadgeColor: '#3752B2',
  // Advanced
  dismissBehavior: 'dismiss_until_triggered', // 'dismiss_until_triggered' | 'dismiss_2min' | 'keep_showing'
};

const initialSalesBadgeSettings = {
  IsActive: true,
  salesBadgeText: 'Special Offer',
  salesBadgeTextColor: '#FF5F5B',
  salesBadgeBackgroundColor: '#f8f4f1',
  salesBadgeType: 'circle',
  salesBadgePosition: 'top_left',
  salesBadgeHasBorder: false,
};

const initialCrossSellEmbedSetting = {
  IsActive: false,

  GeneralTitle: 'You may also like',
  AddToCardButton: 'Add',
  ViewCollectionButton: 'View collection',
  ViewVariantButton: 'View variants',

  WidgetBackgroundColor: '#F7F7F7',
  TextColor: '#303030',
  ButtonBackgroundColor: '#29845A',
  ButtonTextColor: '#ffffff',
};
export async function getThemeExtentionActivation() {
  var isActivated = false;
  var response = await getThemeEnabled();
  // console.log('response in api', response.data);
  isActivated = response.data == 'false' ? true : false;
  return isActivated;
}
export async function hastThemeScope() {
  var isActivated = false;
  var response = await hasThemeAccess();
  isActivated = response;
  return isActivated;
}
export function getShopInfoAdaptor(shopInfo, onboard) {
  // Defensive: a freshly installed shop may not have its plan assigned yet (or
  // a backend hiccup). Default currentPlan so the permissions mapping below
  // doesn't crash the whole app with "Cannot read properties of undefined".
  if (shopInfo && !shopInfo.currentPlan) {
    shopInfo.currentPlan = { permissions: [] };
  }
  if (shopInfo && shopInfo.currentPlan && !shopInfo.currentPlan.permissions) {
    shopInfo.currentPlan.permissions = [];
  }
  // Defensive: `onboard` comes from a SEPARATE getShopStorage() call
  // (service.js's getShopInfo) that can fail/return nothing independently of
  // the shop-info call succeeding — every `onboard.filter(...)` below then
  // crashed the whole app with "Cannot read properties of undefined (reading
  // 'length')" the moment that one call hiccupped. A transient failure of one
  // secondary endpoint must never white-screen the app.
  onboard = Array.isArray(onboard) ? onboard : [];
  var onboardingData = false;
  var filteredOnboard = onboard.filter((onboard) => onboard.key == 'onboardingFirstCampaign');
  if (filteredOnboard.length > 0) {
    onboardingData = filteredOnboard[0].value;
  }
  var onboardingActivateCampaignData = false;
  var filteredOnboardingActivateCampaign = onboard.filter(
    (onboard) => onboard.key == 'onboardingActivateCampaign'
  );
  if (filteredOnboardingActivateCampaign.length > 0) {
    onboardingActivateCampaignData = filteredOnboardingActivateCampaign[0].value;
  }
  var onboardingNeedUpgradeCampaignData = false;
  var filteredOnboardingNeedUpgradeCampaign = onboard.filter(
    (onboard) => onboard.key == 'onboardingNeedUpgradeCampaign'
  );
  if (filteredOnboardingNeedUpgradeCampaign.length > 0) {
    onboardingNeedUpgradeCampaignData = filteredOnboardingNeedUpgradeCampaign[0].value;
  }
  var onboardingDismissData = false;
  var filteredOnboardingDismiss = onboard.filter((onboard) => onboard.key == 'onboardingDismiss');
  if (filteredOnboardingDismiss.length > 0) {
    onboardingDismissData = filteredOnboardingDismiss[0].value;
  }
  var onboardingThemeExtensionData = false;
  var filteredOnboardingThemeExtension = onboard.filter(
    (onboard) => onboard.key == 'onboardingThemeExtension'
  );
  if (filteredOnboardingThemeExtension.length > 0) {
    onboardingThemeExtensionData = filteredOnboardingThemeExtension[0].value;
  }
  var onboardingThemeExtension2Data = false;
  var filteredOnboardingThemeExtension2 = onboard.filter(
    (onboard) => onboard.key == 'onboardingThemeExtension2'
  );
  if (filteredOnboardingThemeExtension2.length > 0) {
    onboardingThemeExtension2Data = filteredOnboardingThemeExtension2[0].value;
  }
  // video dismiss
  var onboardingVideoDismissData = false;
  var filteredOnboardingThemeExtension2videodismiss = onboard.filter(
    (onboard) => onboard.key == 'onboardingVideo'
  );

  if (filteredOnboardingThemeExtension2videodismiss.length > 0) {
    onboardingVideoDismissData = filteredOnboardingThemeExtension2videodismiss[0].value;
  }
  //endvideodismis

  // onboardingFinalEnableCheck
  let onboardingFinalEnableCheck = false;
  let filteredOnboardingFinalEnableCheck = onboard.filter(
    (onboard) => onboard.key == 'onboardingFinalEnableCheck'
  );
  if (filteredOnboardingFinalEnableCheck.length > 0) {
    onboardingFinalEnableCheck = filteredOnboardingFinalEnableCheck[0].value;
  }
  //console.log('shopinfo', shopInfo);

  // Static feature flag for UI (later connect to API)
  const embeddedSetting = false;

  //later
  // const embeddedSetting = Boolean(shopInfo?.embeddedSetting);

  return {
    id: shopInfo?.id,
    customer_email: shopInfo.ownerEmail,
    domain: shopInfo.shopifyDomain,
    shop_owner: shopInfo.ownerName,
    ownerEmail: shopInfo.ownerEmail,
    name: shopInfo.name,
    phone: shopInfo.ownerPhoneNumber,
    shopify_domain: shopInfo.shopifyDomain,
    contact_email: shopInfo.ownerEmail,
    myshopify_domain: shopInfo.shopifyDomain,
    money_format: shopInfo.moneyFormat,
    money_with_currency_format: shopInfo.moneyWithCurrencyFormat,
    iana_timezone: shopInfo.ianaTimezone,
    timezone: shopInfo.timezone,
    currency: shopInfo.currency,
    shopify_plan: shopInfo.planName,
    country: shopInfo.country,
    isTest: shopInfo.isTest,
    created_at: shopInfo.createdAt,
    primary_locale: shopInfo.primaryLocale,
    shop_locales: shopInfo.shopLocales || [],
    currentPlan: {
      currentPlanId: shopInfo.currentPlan?.id,
      currentPlanPeriod: shopInfo.currentPlanPeriod === 'monthly' ? 0 : 1,
      CurrentPlanUser: '',
      planName: shopInfo.currentPlan?.name,
    },
    embeddedSetting,
    // TODO: fake data
    trialEligible: true,
    permissions: {
      can_set_schedule: shopInfo.currentPlan.permissions.includes('campaign_start_schedule'),
      can_set_exclude_product: shopInfo.currentPlan.permissions.includes(
        'campaign_exclude_products'
      ),
      can_set_discount_type: shopInfo.currentPlan.permissions.includes('campaign_start_schedule'),
      can_set_onFly_campaign: true,
      campaign_quantity_and_volume_discount_theme_extension:
        shopInfo.currentPlan.permissions.includes(
          'campaign_quantity_and_volume_discount_theme_extension'
        ),
      can_set_General_Custom_Badge: shopInfo.currentPlan.permissions.includes(
        'can_set_General_Custom_Badge'
      ),
      // Custom wholesale Discount progress bar (Premium and higher). Without it the
      // merchant is limited to the global default widget.
      can_set_custom_progress_bar: shopInfo.currentPlan.permissions.includes(
        'can_set_custom_progress_bar'
      ),
    },
    canAddCampaign: true,
    onboardingFirstCampaignPassed: onboardingData,
    onboardingActivateCampaignPassed: onboardingActivateCampaignData,
    onboardingNeedUpgradeCampaign: onboardingNeedUpgradeCampaignData,
    onboardingThemeExtension: onboardingThemeExtensionData,
    onboardingThemeExtension2: onboardingThemeExtension2Data,
    onboardingVideo: onboardingVideoDismissData,
    onboardingFinalEnableCheck: onboardingFinalEnableCheck,
    onboardingDismiss: onboardingDismissData,
    onboardingFirstCampaign: onboardingData,
    onboardingActivateCampaign: onboardingActivateCampaignData,
    weeklyDigestEnabled: shopInfo.weeklyDigestEnabled ?? false,
    weeklyDigestEmail: shopInfo.weeklyDigestEmail ?? null,
    functionOrderNote: shopInfo.functionOrderNote,
    functionProductNote: shopInfo.functionProductNote,
    productCountdownSettings: isEmpty(shopInfo.productCountdownSettings)
      ? initialProductCountdownSettings
      : shopInfo.productCountdownSettings,
    productEmbedSettings: isEmpty(shopInfo.productEmbedSettings)
      ? initialProductEmbedSetting
      : shopInfo.productEmbedSettings,
    cartEmbedSettings: isEmpty(shopInfo.cartEmbedSettings)
      ? initialCartEmbedSetting
      : shopInfo.cartEmbedSettings,
    inventoryEmbedSettings: isEmpty(shopInfo.InventoryEmbedSettings)
      ? initialInventoryEmbedSetting
      : shopInfo.InventoryEmbedSettings,
    shippingEmbedSettings: isEmpty(shopInfo.shippingEmbedSettings)
      ? initialShippingEmbedSetting
      : { ...initialShippingEmbedSetting, ...shopInfo.shippingEmbedSettings },
    bundleEmbedSettings: isEmpty(shopInfo.bundleEmbedSettings)
      ? initialBundleEmbedSetting
      : shopInfo.bundleEmbedSettings,
    crossSellEmbedSettings: isEmpty(shopInfo.CrossSellSettings)
      ? initialCrossSellEmbedSetting
      : shopInfo.CrossSellSettings,
    salesBadgeSettings: isEmpty(shopInfo.salesBadgeSettings)
      ? initialSalesBadgeSettings
      : { ...initialSalesBadgeSettings, ...shopInfo.salesBadgeSettings },
    bogoModalSettings: isEmpty(shopInfo.bogoModalSettings)
      ? initialBogoModalSetting
      : shopInfo.bogoModalSettings,
    bogoFabSettings: isEmpty(shopInfo.bogoFabSettings)
      ? initialBogoFabSetting
      : shopInfo.bogoFabSettings,
    notification: {
      theme_extension: {
        show: true,
        count: 0,
      },
    },
  };
}
